/** biome-ignore-all lint/correctness/useHookAtTopLevel: <hoc라 어쩔 수 없음. 추후에 컴포넌트를 분리해야 함.> */
'use client';

import { tokenRepository } from 'Shared/network';
import { createReturnUrl } from 'Shared/utils/client';
import { LINK } from '@constants';
import { useGlobalModalStore } from 'app/_hook';
import { usePathname, useRouter } from 'next/navigation';
import type { ComponentType } from 'react';
import { useEffect } from 'react';

export const WithLogin = <P extends object>(Component: ComponentType<P>) => {
  return function Hoc(props: P & { token: string | undefined }) {
    const router = useRouter();
    const pathname = usePathname();
    const { getValue } = useGlobalModalStore();
    const { setConfirmModal } = getValue('actions');

    useEffect(() => {
      const getToken = () => {
        tokenRepository.getToken().then((accessToken) => {
          if (!accessToken) {
            setConfirmModal({
              content: `본 서비스는 회원만 이용이 가능해요.\n로그인할까요?`,
              exitHandler: () => {
                router.replace(LINK.HOME);
              },
              hasCloseButton: false,
              onClickFillButton: () => {
                router.replace(`${LINK.LOGIN}${createReturnUrl(pathname)}`);
              },
              onClickOutlineButton: () => {
                router.replace(LINK.HOME);
              },
            });
            return;
          }
        });
      };

      getToken();
    }, [props.token]);

    if (!props.token) return null;
    return <Component {...props} />;
  };
};
